module.exports = __webpack_public_path__ + "static/forest-a13292b3bc09320a4a2cdc84aa48a382.png";